import React from 'react';
import '../../../../assets/css/screens/serviceprovider/dashboard/succes page/SuccessPage.css';

export default function SuccessPage() {
  const handleDashboardClick = (e) => {
    e.preventDefault();
    // Replace with your actual worker dashboard route
    window.location.href = '/worker-dashboard';
  };

  return (
    <div className="success-page">
      <div className="card">
        <div className="badge-wrap">
          <div className="badge-ring"></div>
          <svg className="check" viewBox="0 0 96 96">
            <path className="check-path" d="M30 50 L44 64 L68 36" />
          </svg>
          <span className="sparkle s1">✦</span>
          <span className="sparkle s2">✦</span>
          <span className="sparkle s3">✦</span>
        </div>

        <h1>You're all set!</h1>
        <p className="sub">
          Your identity has been verified with <b>Stripe</b>. Your WorkHub
          account is now fully active and ready to earn.
        </p>

        <div className="status-pill">
          <span className="status-dot"></span>
          Verification complete
        </div>

        <a href="#" className="btn" onClick={handleDashboardClick}>
          Go to Dashboard
        </a>
        <p className="footnote">
          Payouts and bidding are now unlocked. Questions?{' '}
          <a href="#">Contact support</a>
        </p>
      </div>
    </div>
  );
}